import { useHistory } from 'react-router-dom';
import logoDlGo from '../../../assets/images/dlocalGo-icon.svg';
import logoVerticalDlGo from '../../../assets/images/dlocalGo.svg';
import { Routes } from '../../../config/routes';
import './styles.scss';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  type?: 'vertical' | 'horizontal';
  goHomeDisabeld?: boolean;
}

const Logo = ({ size, type, goHomeDisabeld }: LogoProps) => {
  const history = useHistory();
  return (
    <div
      className={`logo ${goHomeDisabeld ? 'logo_go_home_disabled' : ''}`}
      onClick={() => {
        if (!goHomeDisabeld) history.push(Routes.HOME);
      }}
    >
      <img
        src={(type === 'vertical' && logoVerticalDlGo) || (type === 'horizontal' && logoVerticalDlGo) || logoDlGo}
        className={`logo_img ${size ? `logo_img_${size.toLowerCase()}` : ''}`}
        alt="logo"
      />
    </div>
  );
};

export default Logo;
